import axios from 'axios'

import {
  getBreadcrumb
} from '@/core/util'

export default {
  namespaced: true,
  state: {
    organizations: sessionStorage.getItem('organizations') ?
      JSON.parse(sessionStorage.getItem('organizations')) : false
  },
  mutations: {
    update(state, organizations) {
      state.organizations = organizations
      sessionStorage.setItem('organizations', JSON.stringify(organizations))
    },
    reset(
      state
    ) {
      state.organizations = false
      sessionStorage.removeItem('organizations')
    }
  },
  actions: {
    async fetch({
      commit,
      state
    }, force) {
      if (state.organizations !== false && force !== true) {
        return
      }
      state.organizations = false
      const res = await axios('/common/organization/')
      commit('update', await res.data)
    },
    reset({
      commit
    }) {
      commit('reset')
    }
  },
  getters: {
    organization: state => (id, breadcrumb) => {
      if (state.organizations === false) {
        return null
      }
      let result = []
      getBreadcrumb(id, Object.values(state.organizations), result)
      if (result === false) {
        return null
      }
      if (breadcrumb) {
        return result
      }
      if (!result.length) {
        return null
      }
      let fullname = result.map(item => item.name).join(' / ')
      result = result.pop()
      result.fullname = fullname
      return result
    },
    organizations: state => {
      return state.organizations
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/OrganizationStore.js